var _title, _defs, _path, _rect, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const Svg4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 128 128"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Merchant")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".MerchantCrewClass-1{opacity:0.66;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M52.37,104.33l-23.49,11h71.54L76.76,104.31A31.06,31.06,0,0,0,52.37,104.33Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 61.42,
  y: 38.96,
  width: 6.3,
  height: 56.39
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "MerchantCrewClass-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.14,68.5H11.53L6.79,79.2a2.84,2.84,0,0,0,2.6,4H49.28a2.84,2.84,0,0,0,2.6-4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.55,68.5H80.94L76.21,79.2a2.83,2.83,0,0,0,2.6,4h39.88a2.79,2.79,0,0,0,2.38-1.29,2.82,2.82,0,0,0,.22-2.7Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.54,61.69l12.2-27.57h0a2.84,2.84,0,0,1,5.19,0l12.2,27.57h5L36.2,32.43H91.88L78.94,61.69h5l12.2-27.57h0a2.84,2.84,0,0,1,5.2,0l12.19,27.57h5l-13-29.42a7.33,7.33,0,0,0-6.66-4.42H67.72V12.34h-6.3v15.5H29.2a7.33,7.33,0,0,0-6.66,4.42l-13,29.42Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.16,68.5h-5l4.74,10.7a2.84,2.84,0,0,1-2.6,4H9.39a2.84,2.84,0,0,1-2.6-4l4.74-10.7h-5L2.6,77.34A7.44,7.44,0,0,0,9.39,87.78H49.28a7.44,7.44,0,0,0,6.79-10.44Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M121.57,68.5h-5l4.74,10.7a2.82,2.82,0,0,1-.22,2.7,2.79,2.79,0,0,1-2.38,1.29H78.81a2.83,2.83,0,0,1-2.6-4l4.73-10.7h-5L72,77.34a7.44,7.44,0,0,0,6.8,10.44h39.88a7.44,7.44,0,0,0,6.8-10.44Z"
})));
export default Svg4;